import { range } from "lodash";
import React, { Fragment, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import "./index.css";

const CategoryItem = ({ index, inCategory, onChange, onSave, brand_data }) => {
  const [categoryTitle, setCategoryTitle] = useState("");
  const [categoryHex, setCategoryHex] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  useEffect(() => {
    if (inCategory) {
      const { categoryTitle, categoryHex } = inCategory;
      if (categoryTitle) setCategoryTitle(categoryTitle);
      if (categoryHex) setCategoryHex(categoryHex);
    }
  }, [inCategory]);
  // handler
  const handleChangeCategoryTitle = ({ target }) => {
    setCategoryTitle(target.value);
    const category = {
      categoryTitle: target.value,
      categoryHex,
    };
    onChange(category);
  };

  const handleChangeCategoryHex = ({ target }) => {
    setCategoryHex(target.value);
    const category = {
      categoryTitle,
      categoryHex: target.value,
    };
    onChange(category);
  };

  const handleClickEdit = () => {
    if (isEditing) {
      console.log("save");
      onSave();
    }
    setIsEditing(!isEditing);
  };
  return (
    <div className="category-item">
      <p>{index + 1}</p>
      <input
        type="text"
        className="form-control type-input ml-4"
        placeholder="Input category name..."
        onChange={handleChangeCategoryTitle}
        value={categoryTitle}
        disabled={!isEditing}
      />
      <div
        className="color-circle ml-4"
        style={{ backgroundColor: categoryHex }}
      />
      <input
        type="text"
        className="form-control color-input ml-4"
        placeholder="Input color hex... #ffffff"
        onChange={handleChangeCategoryHex}
        value={categoryHex}
        disabled={!isEditing}
      />
      <button
        className="btn btn-brand-hex ml-2 btn-white"
        style={{
          "--hover-color": brand_data.hex ? brand_data.hex : "white",
          "--hover-text-color": brand_data.white ? "white" : "black",
          backgroundColor: "white",
          color: "black",
        }}
        onClick={handleClickEdit}
      >
        {isEditing ? "Save" : "Edit"}
      </button>
    </div>
  );
};

const UserCategories = () => {
  const location = useLocation();
  const history = useHistory();
  const [brand_data, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [userCategories, setUserCategories] = useState([]);
  const [categorisationCount, setCategorisationCount] = useState(12);

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);
      setLoading(true);
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (brand_data) {
          console.log("brand_data", brand_data);
          setBrandData(brand_data);
          const { userCategories } = brand_data;
          if (userCategories && userCategories.length > 0) {
            setUserCategories(userCategories);
            if (userCategories.length > 12) {
              setCategorisationCount(userCategories.length);
            }
          }
          setLoading(false);
        }
      });
    }
  }, [location]);
  // handler
  const handleChangeCategory = (index) => (category) => {
    const newCategories = [...userCategories];
    newCategories[index] = category;
    setUserCategories(newCategories);
  };

  const handleSave = () => {
    Firebase.updateBrandDataById(brand, { userCategories });
  };

  const addCategorisation = () => {
    if (categorisationCount < 50) {
      setCategorisationCount(categorisationCount + 1);
    }
  };
  console.log("-------", userCategories);

  return (
    <div id="page-container">
      <Header
        username={username}
        role={role}
        logo={brand_data.logo}
        brand={brand}
        brandName={brand_data.name}
        is_property_brand={brand_data.is_property_brand}
      />
      <main id="main-container" className="user-category-container">
        {loading && (
          <div className="loading">
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
          </div>
        )}
        {!loading && (
          <Fragment>
            <div className="categories-container">
              {range(categorisationCount).map((item, i) => (
                <Fragment key={i}>
                  <CategoryItem
                    index={item}
                    inCategory={userCategories[item]}
                    onChange={handleChangeCategory(item)}
                    onSave={handleSave}
                    brand_data={brand_data}
                  />
                </Fragment>
              ))}
            </div>
            {userCategories.length >= 12 && categorisationCount < 50 && (
              <button
                className="btn btn-brand-hex btn-white"
                style={{
                  "--hover-color": brand_data.hex ? brand_data.hex : "white",
                  "--hover-text-color": brand_data.white ? "white" : "black",
                  backgroundColor: "white",
                  color: "black",
                  width: "300px",
                  marginBottom: "50px",
                  marginTop: "20px",
                }}
                onClick={addCategorisation}
              >
                Add a new user categorisation
              </button>
            )}
          </Fragment>
        )}
      </main>
    </div>
  );
};

export default UserCategories;



// WEBPACK FOOTER //
// ./src/screens/UserCategories/index.js